module.exports = __webpack_public_path__ + "img/watford.9f9e366c.png";